<!--
  --
  -- オプション写真コンポーネント
  --
  -->
<template>
  <v-sheet outlined rounded v-if="src">
    <img
      class="d-block w-full h-auto rounded"
      :src="src"
    />
  </v-sheet>
</template>

<script>
export default {
  name: 'COptionImage',
  props: {
    src: {
      type: String
    }
  }
}
</script>
